// removed by extract-text-webpack-plugin
module.exports = {"bannerAd":"styles__bannerAd__1WTrt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BannerAd/styles.scss
// module id = 883
// module chunks = 0